'use strict';
import AOS from 'aos';

// Blocks:
import {blockNewsBlock} from './scripts/blocks/news-block.js';
import {sliderNewsBlock} from "./scripts/blocks/slider-news-block.js";

// Generally scripts:
// import {cookiesInfoBox} from "./scripts/cookies-info-box.js";
import {buttonFacebookBox} from "./scripts/button-facebook-box.js";
import {mainBarNav} from './scripts/main-bar-nav.js';
import {windowSharing} from './scripts/window-sharing.js';
import {galleryModal} from './scripts/gallery-modal.js';
import {backToTop} from './scripts/btnBackToTop.js'
import { jarallax } from "jarallax";
import {googleMap} from "./scripts/google-map.js";
// import {ajaxSettings} from "./scripts/ajaxSettings.js";

AOS.init();

window.addEventListener('load', function() {
    AOS.refresh();
});

mainBarNav();
galleryModal();
// cookiesInfoBox();
sliderNewsBlock();
blockNewsBlock();
buttonFacebookBox();
windowSharing();
backToTop();
googleMap();
// ajaxSettings();

jarallax(document.querySelectorAll(".jarallax"), {
    speed: 0.5,
});

// Fix for mobile device browsers for 100vh
document.addEventListener("DOMContentLoaded", function() {
    const setVhProperty = () => {
        const vh = window.innerHeight * 0.01;
        document.documentElement.style.setProperty('--vh', `${vh}px`);
    };

    setVhProperty();

    window.addEventListener('resize', setVhProperty);
    window.addEventListener('orientationchange', setVhProperty);

    if (window.visualViewport) {
        window.visualViewport.addEventListener('resize', setVhProperty);
    }
});

// Google Analytics
document.addEventListener("DOMContentLoaded", function() {
    if(getCookie("cookie-ga")!=="true") {
        return;
    }
    const cookieSettings = document.querySelector(".ho-cookies-btn-cookies-bar");
    if(!cookieSettings.dataset.ga) {
        return;
    }
    const ga = cookieSettings.dataset.ga;
    const s=document.createElement("script");
    s.src="https://www.googletagmanager.com/gtag/js?id="+ga;
    s.async=true;
    document.head.appendChild(s);

    window.dataLayer=window.dataLayer||[];
    function gtag(){dataLayer.push(arguments);}
    gtag('js',new Date());
    gtag('config',ga);
});



